import { WidgetUnit } from 'types';

export function getResultProp(
  resultId: string,
  units: Record<string, WidgetUnit>,
): object {
  return units[resultId]?.resultProp;
}

export function isSponsored(
  resultId: string,
  units: Record<string, WidgetUnit>,
): boolean {
  return units[resultId]?.isSponsored;
}
